import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { FieldError } from './models/field-error';
import { FormFieldConfig } from './models/form-field-config';
import { FormControlType } from './enums';
import { FieldDescriptor } from './models/field-descriptor';
import { FieldOptionsDescriptor } from './models/field-options-descriptor';
import { IdValue } from './models/id-value';

@Injectable()
export class FormUtils {

    constructor() {

    }

    static getErrorRepresentation(error): Array<FieldError> {
        if (!error) {
            return null;
        }

        if (typeof error === 'object') {
            var data = {};
            var errorDescription: string;
            var response = new Array<FieldError>();

            Object.keys(error).forEach(prop => {
                data = null;

                if (typeof error[prop] === 'object') {
                    data = error[prop];
                }

                errorDescription = this.getKnownErrorDescription(prop, data);

                if (errorDescription) {
                    response.push(new FieldError(prop, errorDescription));
                }
            });

            return response;
        } else {
            return error;
        }
    }

    static getKnownErrorDescription(name: string, data: any): string {
        switch (name) {
            case 'required': {
                return 'This field is required.';
            }
            case 'email': {
                return 'Invalid email address.';
            }
            case 'maxlength': {
                if (data) {
                    return `The max length for this field is ${data.requiredLength} and the actual length is ${data.actualLength}.`;
                } else {
                    return 'The actual length for this field is higher than the permitted.';
                }
            }
            case 'minlength': {
                if (data) {
                    return `The min length for this field is ${data.requiredLength} and the actual length is ${data.actualLength}.`;
                } else {
                    return 'The actual length for this field is lower than the permitted.';
                }
            }
            default: {
                if (data) {
                    if (typeof data === 'object' && data['message']) {
                        return data['message'];
                    } else {
                        return data.toString();
                    }
                }

                return null;
            }
        }
    }

    static processInlineArrays(model: any, sectionId: any) {
        if (!model || !model.formFieldsConfig) {
            return;
        }

        const additionalConfigs = new Array<FormFieldConfig>();

        // Add the properties to the model.
        model.formFieldsConfig.forEach((propInfo) => {
            const info = <FormFieldConfig>propInfo;

            if (info.fieldInfo.type === FormControlType.inlineArray) {
                const data = model[info.fieldInfo.name];

                // Iterate over every record in the array.                
                data.forEach((item, index) => {
                    const config = new FormFieldConfig();

                    // Set the field info.
                    config.fieldInfo = new FieldDescriptor(item[info.inlineOptions.captionPropertyName], item[info.inlineOptions.captionPropertyName], 1, null, FormUtils.getTextFormControlType(item[info.inlineOptions.dataTypePropertyName]), sectionId, null, null, true);
                    config.fieldInfo.name = `${info.fieldInfo.name}_${index}`;
                    model[config.fieldInfo.name] = item[info.inlineOptions.valuePropertyName];

                    // Set the sise.
                    config.size = info.size;

                    // Set the options.
                    if (item[info.inlineOptions.fixedValuesPropertyName]) {
                        const options = _.map(item[info.inlineOptions.fixedValuesPropertyName], option => new IdValue(option, option));
                        config.options = new FieldOptionsDescriptor('id', 'value', options);
                    }

                    additionalConfigs.push(config);
                });
            }
        });

        if (additionalConfigs.length > 0) {
            additionalConfigs.forEach(item => {
                model.formFieldsConfig.push(item);
            });
        }
    }

    static getTextFormControlType(type: number): FormControlType {
        switch (type) {
            case 0:
                return FormControlType.text;
            case 1:
                return FormControlType.number;
            case 2:
                return FormControlType.select;
            case 3:
                return FormControlType.autoComplete;
            case 5:
                return FormControlType.date;            
            default:
                return FormControlType.text;
        }
    }
}